




































import { Vue, Component, Prop } from "vue-property-decorator";
import { SlideInterface } from "@/interfaces/index.ts";

@Component({})
export default class SlidesPage extends Vue {
  slideArray: Array<SlideInterface> = [
    {
      title: "Organize",
      explanation: "Store each meal in an organized timetable with notes",
      image: require("@/assets/images/slide-1.png")
    },
    {
      title: "Randomize",
      explanation: "Change the order of your timetable at the push of a button",
      image: require("@/assets/images/slide-2.png")
    },
    {
      title: "Sync",
      explanation:
        "Store all your timetables online and access them from any other device",
      image: require("@/assets/images/slide-3.png")
    }
  ];

  currentIndex: number = 0;

  mounted() {}

  goToPreviousSlide(): void {
    this.currentIndex = this.currentIndex === 0 ? 0 : this.currentIndex - 1;
  }

  goToNextSlide(): void {
    this.currentIndex =
      this.currentIndex === this.slideArray.length - 1
        ? this.slideArray.length - 1
        : this.currentIndex + 1;

    if (this.currentIndex === this.slideArray.length - 1)
      this.$router.push({ name: "home" });
  }

  // Development
  goToHomePage(): void {
    this.$router.push({ name: "home" });
  }
  // Development
}
